<h2 mat-dialog-title class="dialog-header">{{'locker.box.details.title'|traduccion}} {{box?.lockerNumber}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content mat-typography" *ngIf="form">

    <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.lockerId'|traduccion}}</mat-label>
            <input matInput type="number" formControlName="lockerNumber" />
            <app-form-error [control]="form.get('lockerNumber')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.product'|traduccion}}</mat-label>
            <mat-select formControlName="productId">
                <mat-option *ngFor="let product of products" [value]="product.id">
                    {{ product.id }} - {{ product.category.code }}
                </mat-option>
            </mat-select>
            <app-form-error [control]="form.get('productId')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.board'|traduccion}}</mat-label>
            <input matInput type="number" formControlName="board" />
            <app-form-error [control]="form.get('board')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.box'|traduccion}}</mat-label>
            <input matInput type="number" formControlName="box" />
            <app-form-error [control]="form.get('box')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.password'|traduccion}}</mat-label>
            <input matInput type="text" formControlName="password" />
            <app-form-error [control]="form.get('password')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.doorBox'|traduccion}}</mat-label>
            <mat-select formControlName="doorBox">
                <mat-option value="OPEN">{{'locker.box.details.form.doorBox.open'|traduccion}}</mat-option>
                <mat-option value="CLOSE">{{'locker.box.details.form.doorBox.close'|traduccion}}</mat-option>
            </mat-select>
            <app-form-error [control]="form.get('doorBox')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.priority'|traduccion}}</mat-label>
            <input matInput type="number" formControlName="priority" />
            <app-form-error [control]="form.get('priority')" ></app-form-error>
        </mat-form-field>

         <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.channel'|traduccion}}</mat-label>
            <mat-select formControlName="channel">
                <mat-option value="ANY_CHANNEL">{{'ANY_CHANNEL'|traduccion}}</mat-option>
                <mat-option value="ONLINE_CHANNEL">{{'ONLINE_CHANNEL'|traduccion}}</mat-option>
                <mat-option value="IN_STORE_CHANNEL">{{'IN_STORE_CHANNEL'|traduccion}}</mat-option>
            </mat-select>
            <app-form-error [control]="form.get('channel')" ></app-form-error>
        </mat-form-field>

        <div class="flex items-center space-x-4 col-span-2">
            <mat-checkbox formControlName="enabled">{{'locker.box.details.form.enabled'|traduccion}}</mat-checkbox>
            <app-form-error [control]="form.get('enabled')" ></app-form-error>
        </div>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.createdAt'|traduccion}}</mat-label>
            <input matInput [value]="form.value.createdAt | date: appService.FORMAT_DATETIME" disabled />
            <app-form-error [control]="form.get('createdAt')" ></app-form-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'locker.box.details.form.updatedAt'|traduccion}}</mat-label>
            <input matInput [value]="form.value.updatedAt | date: appService.FORMAT_DATETIME" disabled />
            <app-form-error [control]="form.get('updatedAt')" ></app-form-error>
        </mat-form-field>

    </form>


</mat-dialog-content>


<mat-dialog-actions align="end" class="dialog-footer">
    <button *ngIf="!isNew" mat-stroked-button color="accent" (click)="openManual()">{{'locker.box.details.action.openBox'|traduccion}}</button>
    <span class="spacer"></span>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="confirm()">{{'locker.box.details.action.save'|traduccion}}</button>
    <button *ngIf="!isNew" mat-stroked-button color="warn" (click)="deleteLocker()">{{'locker.box.details.action.delete'|traduccion}}</button>
</mat-dialog-actions>
